export default __webpack_public_path__ + "static/media/Photo 12 - BR - Porosité.365870e0.png";